import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckRefurbished = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 14",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.59 10.58L1.42 6.41L0 7.82L5.59 13.41L17.59 1.41L16.18 0L5.59 10.58Z",
		fill: "currentColor"
	})
});
export { SvgCheckRefurbished as ReactComponent };
